import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {LoadingDialog} from '../../../../../_metronic/_partials/controls';

export function AgentsIncomesLoadingDialog() {
  const {isLoading} = useSelector(
    (state) => ({isLoading: state.invoices.listLoading}),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading}/>;
}
